import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import CreateApplicationModal from "./modals/CreateApplicationModal";

class Applications extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        showApplicationModal: false,
        items: []
    };
    getApplications = new BackEnd.ApplicationsAdmin.GetApplications(this);

    async componentDidMount() {
        await this.fetchApplications();
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-gear-a"/> Система /
                                </span> Приложения
                            </h1>
                        </div>
                        <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                            <button type="button" className="btn btn-primary btn-block"
                                    onClick={() => this.setState({showApplicationModal: true})}>Добавить
                            </button>
                        </div>
                    </div>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Название</th>
                                <th>Токен</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(item =>
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.token}</td>
                                </tr>
                            )}
                            {
                                !this.state.items.length &&
                                <tr>
                                    <td className="text-center" colSpan="2">Приложений нет</td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <CreateApplicationModal show={this.state.showApplicationModal}
                                        onSave={() => this.fetchApplications()}
                                        onHide={() => this.setState({showApplicationModal: false})}/>
            </div>
        );
    }

    async fetchApplications() {
        const items = await this.getApplications.call();
        this.setState({items});
    }
}

export default Applications;


// WEBPACK FOOTER //
// ./src/pages/System/Applications/Applications.js